import styled from 'styled-components/native'

export const CollapseButtonContainer = styled.View`
	right: 0;
	position: absolute;
`
